import Link from "next/link";

import styles from "./siteChrome.module.css";

export function SiteFooter() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className={styles.footer}>
      <div className={styles.footerLinks}>
        <Link href="/nous-contacter">Nous contacter</Link>
        <Link href="/faq">FAQ</Link>
        <Link href="/politique-confidentialite">Politique de confidentialité</Link>
        <Link href="/conditions-generales">Conditions générales de vente et d&apos;utilisation</Link>
      </div>

      <div className={styles.footerBottom}>
        <p className={styles.footerCopyright}>&copy; {currentYear} Tous droits réservés, Pharmapp.</p>
        <p className={styles.footerCredit}>
          Produit de{" "}
          <Link href="https://blprog.com" target="_blank" rel="noreferrer" className={styles.footerCreditLink}>
            BL Prog
          </Link>
        </p>
      </div>
    </footer>
  );
}
